import Vue from "vue";
import Vuex from "vuex";
import app from "./app";
import user from "./user";
import house from "./house";
import permission from "./permission";
import getters from "./getters";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    app,
    user,
    permission,
    house
  },
  getters
});
